export { CollectiblesLayout } from './CollectiblesLayout'
